import { Download } from '@mui/icons-material'
import { Button, CircularProgress } from '@mui/material'
import React, { useState } from 'react'
import { useListContext, useNotify, useTranslate } from 'react-admin'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { accountStateServices } from 'src/services/reservation/accout-state/AccountState.service'

export const ExportButton = () => {
    const { filters, hasCredit, work_unit_id, business_unit_id, seller_filter } = useListContext()
    const translate = useTranslate()
    const notify = useNotify()
    const [loading, setLoading] = useState(false)

    const handleExport = async () =>{
        setLoading(true)
        await accountStateServices.exportReservations(
          filters, 
          hasCredit, 
          business_unit_id, 
          work_unit_id, 
          seller_filter,
          hasPermissionFunction('account-state', 'show_tma')
        )
        .then(()=>{
          const user = JSON.parse(localStorage.getItem('user'))
          notify('ra.message.export_success', {type:'success', messageArgs:{email:user?.email ?? ''}})
        })
        .catch(()=>{
          notify('ra.message.export_error', {type:'error'})
        })
        .finally(()=>{
            setLoading(false)
        })
    }

  return (
    <Button
      onClick={handleExport}
      disabled={loading}
      startIcon={loading ? <CircularProgress size={20} /> : <Download fontSize='small' />}
      sx={{ lineHeight: '1.5'}}
      size='small'
    >
      {translate('ra.action.export')}
    </Button>
  )
}

